import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export default function inFieldsetStyle(_ref) {
  var {
    position,
    stack,
    isUnderlined,
    squareBottomBorder,
    borderRadius
  } = _ref;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, position === 'bottomRight' ? {
    borderBottomRightRadius: borderRadius
  } : position === 'bottomLeft' ? {
    borderBottomLeftRadius: borderRadius
  } : position === 'bottom' ? {
    borderBottomLeftRadius: borderRadius,
    borderBottomRightRadius: borderRadius
  } : position === 'centerLeft' || position === 'center' || position === 'centerRight' || position === 'inner' ? {} : position === 'right' ? {
    borderBottomRightRadius: borderRadius,
    borderTopRightRadius: borderRadius
  } : position === 'left' ? {
    borderBottomLeftRadius: borderRadius,
    borderTopLeftRadius: borderRadius
  } : position === 'topRight' ? {
    borderTopRightRadius: borderRadius
  } : position === 'topLeft' ? {
    borderTopLeftRadius: borderRadius
  } : position === 'top' ? {
    borderTopLeftRadius: borderRadius,
    borderTopRightRadius: borderRadius
  } : {
    borderRadius
  }), squareBottomBorder ? {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  } : {}), position === 'inner' || position === 'topRight' || position === 'right' || position === 'centerRight' || position === 'bottomRight' ? {
    marginLeft: -1
  } : {}), stack && !isUnderlined ? {
    marginTop: -1
  } : {});
}
//# sourceMappingURL=index.js.map